import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ResearchAuthService } from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: ResearchAuthService, private router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log('event--->>>', event);
                    // this.errorDialogService.openDialog(event);
                }
                return event;
            }),
            catchError((err: HttpErrorResponse) => {
                // // ignore this error
                // if (err.url === ResearchAuthService.RefreshUrl && err.status === 429) {
                //     return of(err);
                // }
                // // ignore errors on login route so we don't pop a modal over the login window
                // if (err.status === 401 && this.router.url === this.authService.loginRoute) {
                //     return of(err);
                // }

                if (err.status === 401) {
                    this.authService.sendUnathenticatedError(err);
                }
                return throwError(err);
            }));
    }
}
